import get from 'lodash/get';
import {
  DOWNLOAD_APPS_ATTRIBUTION_BASE_URLS,
  MOBILE_PLATFORMS,
  VERTICAL_NAMES,
} from '../common/constants/common';

export function getQueryParamsConnector(stringUrl) {
  return /[/]q\?/.test(stringUrl) ? '&' : '?';
}

export function getForceRedirectToPlatformStore(platform, verticalName) {
  let oflParameter = '';

  if (!platform || !verticalName) {
    return oflParameter;
  }

  if (verticalName === VERTICAL_NAMES.products) {
    return oflParameter;
  }

  if (platform === MOBILE_PLATFORMS.ios) {
    const attributionIds = {
      homes: '/trovit-homes/id347012986?mt=8',
      cars: '/trovit-cars/id558532549?mt=8',
      jobs: '/trovit-jobs/id379240463?mt=8',
    };

    oflParameter = `&ofl=http://itunes.apple.com/cl/app${attributionIds[verticalName]}`;
  }
  if (platform === MOBILE_PLATFORMS.android) {
    const attributionIds = {
      homes: '?id=es.roid.and.trovit',
      cars: '?id=com.trovit.android.apps.cars',
      jobs: '?id=com.trovit.android.apps.jobs',
    };

    oflParameter = `&ofl=https://play.google.com/store/apps/details${attributionIds[verticalName]}`;
  }

  return oflParameter;
}

export function generateDownloadUrl(config, trovit, currentUrl, section, platform = null) {
  const origin = `${trovit.origin}`;
  const countryCode = config.countryCode;
  const verticalName = config.verticalName;

  const utmCampaign = {
    network: 'trovit',
    campaign: '',
    advertisingId: '',
    pageviewId: trovit.pageviewId,
    v: get(trovit, ['trackingCodes', `${origin}`]) || '', // tracking code
    section,
  };

  const oflParameter = getForceRedirectToPlatformStore(platform, verticalName);

  const connector = getQueryParamsConnector(currentUrl);
  const linkEncoded = `&link=${encodeURIComponent(
    `${currentUrl}${connector}country=${countryCode}`
  )}`;
  const utmCampaignEncoded = `&utm_campaign=${encodeURIComponent(JSON.stringify(utmCampaign))}`;
  const downloadAppURL = `${
    DOWNLOAD_APPS_ATTRIBUTION_BASE_URLS[verticalName]
  }${oflParameter}${linkEncoded}&efr=1${utmCampaignEncoded}`;

  return downloadAppURL;
}



// WEBPACK FOOTER //
// ./app/utils/downloadLinks.js